var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"barreProgression"},[_c('div',{class:_vm.computedClass,style:(_vm.computedStyle)})])
}
var staticRenderFns = []

export { render, staticRenderFns }